import { PropsWithChildren } from 'react';

import styles from './Card.module.scss';

interface CardProps extends React.PropsWithChildren {
  title: React.ReactNode;
  subtitle: React.ReactNode;
}

const Card = ({ title, subtitle, children }: CardProps) => {
  return (
    <div className={styles.card}>
      <div className={styles.title}>{title}</div>
      <div className={styles.subtitle}>{subtitle}</div>
      <div>{children}</div>
    </div>
  );
};

const Footer: React.FC<PropsWithChildren> = ({ children }) => {
  return <div className={styles.footer}>{children}</div>;
};

Card.Footer = Footer;

export default Card;
